import React from "react";
import { Switch, Route } from "react-router-dom";

import RouteEnum from "./RouteEnum";
//import Home from "../components/Home/Home";
import Shows from "../components/Landing/Shows";
import Advisors from "../components/Landing/Advisors";

const Router = () => {

    return (
        <Switch>
            <Route exact={true} path={RouteEnum.SWATCH} component={() => <Shows company="swatch" />} />
            <Route exact={true} path={RouteEnum.SWATCH_SHOWS} component={() => <Shows company="swatch" />} />
            <Route exact={true} path={RouteEnum.SWATCH_ADVISORS} component={() => <Advisors company="swatch" />} />

            <Route exact={true} path={RouteEnum.SWATCH_ITALY} component={() => <Shows company="swatch-italy" />} />
            <Route exact={true} path={RouteEnum.SWATCH_ITALY_SHOWS} component={() => <Shows company="swatch-italy" />} />
            <Route exact={true} path={RouteEnum.SWATCH_ITALY_ADVISORS} component={() => <Advisors company="swatch-italy" />} />

            <Route exact={true} path={RouteEnum.SWATCH_SWITZERLAND} component={() => <Shows company="swatch-switzerland" />} />
            <Route exact={true} path={RouteEnum.SWATCH_SWITZERLAND_SHOWS} component={() => <Shows company="swatch-switzerland" />} />
            <Route exact={true} path={RouteEnum.SWATCH_SWITZERLAND_ADVISORS} component={() => <Advisors company="swatch-switzerland" />} />

            <Route exact={true} path={RouteEnum.BUNNINGS} component={() => <Shows company="bunnings" />} />
            <Route exact={true} path={RouteEnum.BUNNINGS_SHOWS} component={() => <Shows company="bunnings" />} />
            <Route exact={true} path={RouteEnum.BUNNINGS_ADVISORS} component={() => <Advisors company="bunnings" />} />

            <Route exact={true} path={RouteEnum.BRUNELLO} component={() => <Shows company="brunello" />} />
            <Route exact={true} path={RouteEnum.BRUNELLO_SHOWS} component={() => <Shows company="brunello" />} />
            <Route exact={true} path={RouteEnum.BRUNELLO_ADVISORS} component={() => <Advisors company="brunello" />} />

            <Route exact={true} path={RouteEnum.BENTLEY_UNIVERSITY} component={() => <Shows company="bentleyUniversity" />} />
            <Route exact={true} path={RouteEnum.BENTLEY_UNIVERSITY_SHOWS} component={() => <Shows company="bentleyUniversity" />} />
            <Route exact={true} path={RouteEnum.BENTLEY_UNIVERSITY_ADVISORS} component={() => <Advisors company="bentleyUniversity" />} />

            <Route exact={true} path={RouteEnum.DEMO} component={() => <Shows company="demo" />} />
            <Route exact={true} path={RouteEnum.DEMO_SHOWS} component={() => <Shows company="demo" />} />
            <Route exact={true} path={RouteEnum.DEMO_ADVISORS} component={() => <Advisors company="demo" />} />

            <Route exact={true} path={RouteEnum.ADVISORS} component={Advisors} />
            <Route exact={true} path={RouteEnum.SHOWS} component={Shows} />
            <Route exact={true} component={Shows} />
        </Switch>
    )
};

export default Router;